import { TGetInfrastructureResponse_1 } from 'shared/common/repositories/infrastructure-caching/v4/get-infrastructure';
import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectInfrastructureApiResult(state: TApplicationState): TGetInfrastructureResponse_1 | null {
  return state.infrastructure.data;
}
